import * as React from 'react'
import { Segment } from 'semantic-ui-react'

function getFile() {
  const r: any[] = []
  for (let i = 1; i <= 2; i++) {
    const mod = require('./file/history' + i + '.pdf')
    r.push(mod)
  }
  return r
}

export default class HomeDetailHistoryOrg extends React.Component<
  { style?: React.CSSProperties },
  { file: any[] }
> {
  state = { file: Array() }

  componentDidMount() {
    this.setState({ file: getFile() })
  }

  render() {
    return (
      <div style={{ ...this.props.style }}>
        <Segment>
          ※大阪外国語大学卒業後、中国語/日本語講師、通訳、守山市の広報特派員、琵琶湖博物館協議会委員、滋賀多文化共生推進委員、守山市行政改革委員、守山警察協議会委員を勤めた。
          <br />
          2008年から5年間NPO法人滋賀日中文化交流センターの理事長として活躍。在任中滋賀県多文化共生推進モデル事業にも選ばれた。その後、 翻訳出版活動に尽力した。
          <br />
          詳しい「履歴/職歴」は
          <br />
          <a href={this.state.file[0]} target="_blank" rel="noopener">
            日本語
          </a>
          {' / '}
          <a href={this.state.file[1]} target="_blank" rel="noopener">
            中文
          </a>
          <br />
          2024年より引退・隠居
          <br />
          人生で関わった全ての方に感謝し、ご多幸を！
          <br />
          衷心感谢人生有过联接的所有人士，祝好！
        </Segment>
      </div>
    )
  }
}
